import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-public-pages',
  templateUrl: './public-pages.component.html',
  styles: [
  ]
})
export class PublicPagesComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
